import { Button, Modal } from 'avo-ui'
import clsx from 'clsx'
import Datepicker from 'components/commons/datepicker'
import icWarning from '../../../assets/images/ic-warning.svg'

const ModalExportPointMember = ({ className, show, onHide, isLoading, onExport, value, onChangeDate }) => {
    return (
        <Modal dialogClassName={'max-w-[480px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={clsx('flex flex-col space-y-4 items-center p-10 text-neutral-70', className)}>
                    <img src={icWarning} alt={'ic-warning'} className={'w-12 h-12'} />
                    <p className={'font-semibold'}>{'Export Point Member'}</p>
                    <p className={'text-center'}>{'Please select a date range for the data you want to export.'}</p>
                    <div className={'flex flex-row items-center justify-between pt-4'}>
                        <div className={'space-y-2'}>
                            <p>Start Date</p>
                            <Datepicker
                                className={''}
                                name={'start-date'}
                                value={value?.start_date}
                                onChange={(value) => onChangeDate({ name: 'start_date', value })}
                                format='YYYY-MM-DD'
                                isClearable
                            />
                        </div>
                        <div className={'mt-7 mx-2'}>-</div>
                        <div className={'space-y-2'}>
                            <p>End Date</p>
                            <Datepicker
                                name={'end-date'}
                                value={value?.end_date}
                                onChange={(value) => onChangeDate({ name: 'end_date', value })}
                                format='YYYY-MM-DD'
                                isClearable
                            />
                        </div>
                    </div>
                </div>
                <div className={'flex flex-row px-6 py-3 border-t space-x-3 justify-center'}>
                    <Button type={'outline'} title={'Cancel'} onClick={onHide} />
                    <Button
                        title={'Export'}
                        loading={isLoading}
                        disabled={!value?.start_date && !value?.end_date}
                        onClick={onExport}
                    />
                </div>
            </>
        </Modal>
    )
}

export default ModalExportPointMember
